export enum ReducerEnum {
    entities='entities',
    config='config',
    agency='agency',
}
